import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button"]

  connect() {
    this.boundHandleSubmit = this.handleSubmit.bind(this)
    this.boundHandleSubmitEnd = this.handleSubmitEnd.bind(this)
    this.element.addEventListener("submit", this.boundHandleSubmit)
    // Listen for Turbo events to handle success/failure
    this.element.addEventListener("turbo:submit-end", this.boundHandleSubmitEnd)
  }

  disconnect() {
    this.element.removeEventListener("submit", this.boundHandleSubmit)
    this.element.removeEventListener("turbo:submit-end", this.boundHandleSubmitEnd)
  }

  handleSubmit(event) {
    if (this.hasButtonTarget) {
      const button = this.buttonTarget

      // Store original state for restoration
      this.originalText = button.value || button.textContent
      this.originalHTML = button.innerHTML

      // Disable button and show loading state
      button.disabled = true
      button.classList.add("opacity-75", "cursor-not-allowed")

      if (button.tagName === "INPUT") {
        button.value = "Submitting..."
      } else {
        button.innerHTML = `
          <svg class="animate-spin -ml-1 mr-2 h-5 w-5 inline" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
          Submitting...
        `
      }
    }
  }

  handleSubmitEnd(event) {
    // Re-enable button on any response (success will typically redirect)
    // For error responses (422, 500, etc.), we need to restore the button
    if (this.hasButtonTarget) {
      const button = this.buttonTarget
      const fetchResponse = event.detail?.fetchResponse

      // If it's an error response or if the form is still visible after submission
      // (meaning no redirect happened), restore the button state
      if (!fetchResponse?.succeeded || document.contains(this.element)) {
        this.restoreButton()
      }
    }
  }

  restoreButton() {
    if (!this.hasButtonTarget) return

    const button = this.buttonTarget
    button.disabled = false
    button.classList.remove("opacity-75", "cursor-not-allowed")

    if (button.tagName === "INPUT") {
      button.value = this.originalText || "Submit"
    } else if (this.originalHTML) {
      button.innerHTML = this.originalHTML
    }
  }
}
